<template>
  <div class="row justify-content-center" style="padding-bottom: 20px;">
    <div class="col-lg-6 mt-2">
      <idx-card :title="`${this.$t('menu.settings.integrations.titleApiKey')}`">
        <div class="row">
          <div class="col-12">
            <div class="col-12">
              <div class="col-12 mb-3">
                <p>
                  {{ $t('menu.settings.integrations.descriptionApi') }}
                </p>
              </div>
              <div class="form-group">
                <label class="company-key">
                  {{ $t('menu.settings.integrations.companyKey') }}:</label
                >
                <input
                  type="text"
                  class="form-control"
                  :value="keyEncryption"
                  disabled
                />
              </div>
              <div class="form-group status">
                <div class="custom-switch col-4">
                  <!-- <input
                    type="checkbox"
                    class="custom-control-input"
                    id="enable-config"
                    :title="`${this.$t(
                      'menu.settings.integrations.titleStatus',
                    )}`"
                  />
                  <label class="custom-control-label" for="enable-config">
                    {{ $t('menu.settings.integrations.titleStatus') }}
                  </label> -->
                </div>
              </div>
              <div class="form-group pull-right">
                <button
                  @click="$router.push('/integrations')"
                  class="btn btn-secondary"
                  style="max-width: 300px;"
                >
                  {{ $t('menu.settings.integrations.cancel') }}
                </button>
                <button
                  @click="messageDev"
                  class="btn btn-primary"
                  style="max-width: 300px;"
                >
                  {{ $t('menu.settings.integrations.save') }}
                </button>
              </div>
            </div>
            <GoBackButton />
          </div>
        </div>
      </idx-card>
    </div>
  </div>
</template>
<script>
import swal from 'sweetalert';
import IdxCard from '@/components/molecules/idx-card';
import api from '../../../../../services/api';
import GoBackButton from '../../../../atoms/goback-button';

export default {
  name: 'Integrations',

  data() {
    return {
      userAuth: null,
      publicKey: null,
    };
  },

  components: {
    IdxCard,
    GoBackButton,
  },

  computed: {
    keyEncryption() {
      return `*****${`${this.publicKey}`.substring(5, 55)}*****`;
    },
  },

  methods: {
    messageDev() {
      swal({
        title: 'Em breve',
        text: 'Possibilidade de desabilitar está em desenvolvimento...',
        icon: 'warning',
        buttons: 'Ok',
      });
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    const response = await api.get(`company/${this.userAuth.companyId}`, {
      headers: { 'x-access-token': this.userAuth.token },
    });

    this.publicKey = response.data.publicKey;
  },
};
</script>

<style>
.row.justify-content-center {
  background: #fff;
}

.company-key {
  margin-top: 35px;
}

.status {
  margin-bottom: 45px;
}

/* .idx-card {
  margin-top: 30px;
  margin-bottom: 30px;
} */
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/integrations-webhooks/integration-api/index.vue